import categoriesTree from '@anm/data/video-templates/categories-tree';
import { PageName } from '@anm/data/video-templates/pages';
import isMobile from '@anm/helpers/is/isMobile';

const FIRST_BREADCRUMB = {
  page: 'main',
  name: isMobile() ? '...' : 'free video templates'
};

export const getBreadcrumbsData = (pageName: PageName) =>
  categoriesTree.reduce(
    (acc, mainCategory) => {
      mainCategory.page === pageName && acc.push(mainCategory);

      const subCategory = mainCategory.children.find(
        subCategory => subCategory.page === pageName
      );

      if (subCategory) {
        acc.push(mainCategory);
        acc.push(subCategory);
      }

      return acc;
    },
    [FIRST_BREADCRUMB]
  );
